import React from 'react';
import RateCard from '../jo-components/cards/rateCard/rateCard';
import RateGroupCard from '../jo-components/cards/rateGroupCard/rateGroupCard';
import Button from '../jo-components/ui/button/button';
import Message from '../jo-components/misc/message/message';
import { useTranslation } from 'react-i18next';
import { UUID } from '../../utils/utils';


export default function WaitingListTicket({onSubmit = () => {}, config, isSubmitting = false}) {
    const { t } = useTranslation();
    const title = config.waiting_list_ticket.header.title;
    const subtitle = config.waiting_list_ticket.header.subtitle;
    const informationTitle = config.waiting_list_ticket.message?.title;
    const informationDescription = config.waiting_list_ticket.message?.subtitle;
    const rates_with_group = config.waiting_list_ticket.rates_with_group;
    const rates_without_group = config.waiting_list_ticket.rates;
    const [selectedRates, setSelectedRates] = React.useState({});

    const sortWithDisplayOrder = (a, b) => Object.keys(a).includes('display_order') &&
        Object.keys(b).includes('display_order') ? a['display_order'] - b['display_order'] :
        Object.keys(b).includes('display_order') ? -1 : 1;

    const ratesWithGroup = React.useMemo(() => rates_with_group.sort(sortWithDisplayOrder), [rates_with_group]);
    const ratesWithoutGroup = React.useMemo(() => rates_without_group.sort(sortWithDisplayOrder), [rates_without_group]);

    const total = React.useMemo(() => {
        let quantity = 0;
        for (const rate in selectedRates) {
            quantity += selectedRates[rate]['quantity'];
        }
        return { "quantity": quantity };
    }, [selectedRates]);

    const isDisabledSubmit = React.useMemo(() => {
        return total.quantity === 0;
    }, [total]);

    const _onSubmit = React.useCallback(() => {
        if (isDisabledSubmit) {
            return;
        }
        let selected_rates = [];
        for (const [key, value] of Object.entries(selectedRates)) {
            for (let i = 0; i < value.quantity; i++) {
                selected_rates.push({
                    "auto_generated_ticket_id": UUID(key),
                    "rate": Number(key),
                    "booking":{
                        "booking_uuid": null,
                    },
                });
            }
        }       
        onSubmit({
            data: {
                cart: {'attendees': selected_rates, 'buyer': {}}
            }
        });
    },[selectedRates, onSubmit, isDisabledSubmit]);

    return (
        <div className='neo-rate-step'>
            <h1 className='neo-rate-step-rates-title'>{title}</h1>
            <h2 className='neo-rate-step-rates-subtitle'>{subtitle}</h2>
            <Message type='info' title={informationTitle} description={informationDescription}/>
            <div>
                {ratesWithoutGroup?.map((rate, i) => {
                    return <RateCard key={i} mode='waiting-list' rate={rate} selectedRates={selectedRates} setSelectedRates={setSelectedRates} disable_plus={isSubmitting} disable_minus={isSubmitting} display_rate_description={false} onSubmit={onSubmit}/>
                })}
                {ratesWithGroup?.map((group, i) => {
                    return <RateGroupCard key={i} mode='waiting-list' className='neo-parent-group' group={group} selectedRates={selectedRates} setSelectedRates={setSelectedRates} disable_plus={isSubmitting} disable_minus={isSubmitting} expand_rate_groups={false} onSubmit={onSubmit}/>
                })}
            </div>
            <div className='neo-cta-container'>
                <Button type='primary' isLoading={isSubmitting} className='neo-cta-next' onClick={_onSubmit} label={t('widget.resale.tickets.cta-next')} disabled={isDisabledSubmit}/>
            </div>
        </div>
    )
}
